<template>
    <div>
        <p class="md-layout-item md-size-100 p-0 mb-0">
            You can specify a screen that you can quickly access by clicking the home icon in the main navigation menu
        </p>
        <div class="md-layout">
            <label class="md-layout-item md-large-size-25 md-xlarge-size-20 md-xsmall-size-40 md-form-label">
                Main Screen
            </label>
            <div class="md-layout-item md-large-size-40 md-xlarge-size-30 md-xsmall-size-60">
                <Dropdown v-model="mainScreen" :options="screens" optionLabel="screenDescription" optionValue="screenName"
                          placeholder="Main Screen" class="w-100 md-field" :class="{'p-invalid': mainScreenError}" :disabled="!hasMainScreenPrivilege" />
                <div class="text-danger" v-if="mainScreenError">Please select a screen</div>
            </div>
            <div class="md-layout-item md-large-size-30 md-xlarge-size-35 md-xsmall-size-100 d-flex align-items-center" :class="{'justify-content-right': isMobile}">
                <md-button class="md-cyan-900 ml-5" @click="saveMainScreen" :disabled="!hasMainScreenPrivilege">
                    Update
                </md-button>
            </div>
        </div>
    </div>
</template>

<script>
import { ErrorHelper, UserDataHelper } from "@/api/helpers";
import Mixins from "@/plugins/basicMixins";
import ApiUser from "@/api/methods/ApiUser";
import { PRIVILEGES } from "@/layout/Constants";
import { ROUTER_LINKS } from "@/plugins/Constants";

export default {
    name: "MainScreenForm",
    mixins: [Mixins.ShowToastr, Mixins.Loading, Mixins.DetectMobile],
    data() {
        const user = UserDataHelper.getUser();
        return {
            mainScreen: user ? user.mainScreen : null,
            screens: [],
            mainScreenError: false,
            hasMainScreenPrivilege: UserDataHelper.isPrivilegeExists(user, PRIVILEGES.MAIN_SCREEN),
            link: {
                personal: process.env.VUE_APP_BASE_URL + "#" + ROUTER_LINKS.personal.path,
                business: process.env.VUE_APP_BASE_URL + "#" + ROUTER_LINKS.business.path,
            },
        };
    },
    watch: {
        mainScreen(newValue) {
            if (newValue) {
                this.mainScreenError = false;
            }
        },
    },
    methods: {
        getData() {
            this.showLoading();
            ApiUser.getScreensForMainScreen().then((response) => {
                this.screens = response.data;
                this.hideLoading();
            }).catch((e) => {
                this.hideLoading();
                this.showError(this.name, ErrorHelper.message(e, "Error loading screens"));
            });
        },
        showPrivilegeError() {
            const message = this.$t("messages.feature-access-error")
                .replace("{hrefpersonal}", this.link.personal)
                .replace("{hrefbusiness}", this.link.business);
            this.$emit("privilege-error", message);
        },
        saveMainScreen() {
            if (!this.hasMainScreenPrivilege) {
                this.showPrivilegeError();
                return;
            }
            if (!this.mainScreen) {
                this.mainScreenError = true;
                return;
            }
            this.mainScreenError = false;
            this.showLoading();
            ApiUser.saveMainScreen({ mainScreen: this.mainScreen }).then(() => {
                this.hideLoading();
                this.showToast("saveMainScreen", "Main screen successfully saved", "success");
                this.$emit("saved");
            }).catch((e) => {
                this.hideLoading();
                this.showError(this.name, ErrorHelper.message(e, "Error saving main screen"));
            });
        },
    },
    mounted() {
        this.getData();
        if (!this.hasMainScreenPrivilege) {
            this.showPrivilegeError();
        }
    },
};
</script>
